import { FC } from 'react';
import styled from 'styled-components';

import { Checkbox } from '@idaho-aeyc/ui-kit';
import { TCheckboxProps } from './Checbox.types';

const SCheckbox = styled<FC<TCheckboxProps>>(Checkbox)``;

export default SCheckbox;
